import { lazy } from 'react';

export const CreditProductPage = lazy(
  () => import('./ui/CreditProductPage/CreditProductPage'),
);

export const CreditProductDetailsPage = lazy(
  () => import('./ui/CreditProductDetailsPage/CreditProductDetailsPage'),
);
